// Busca endereço via ViaCEP. Retorna null se o CEP for inválido/não encontrado ou a busca falhar.
export const fetchAddressByCEP = async (cep) => {
  const cleanCep = String(cep || '').replace(/\D/g, '');
  if (cleanCep.length !== 8) return null;

  try {
    const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
    const data = await response.json();

    if (data.erro) return null;

    return {
      street: data.logradouro || '',
      neighborhood: data.bairro || '',
      city: data.localidade || '',
      state: data.uf || 'RJ'
    };
  } catch (error) {
    console.log('Erro ao buscar CEP:', error);
    return null;
  }
};
